import { render } from "./Variant.vue?vue&type=template&id=3f7fdfd6&scoped=true"
import script from "./Variant.vue?vue&type=script&lang=js"
export * from "./Variant.vue?vue&type=script&lang=js"

import "./Variant.vue?vue&type=style&index=0&id=3f7fdfd6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7fdfd6"]])

export default __exports__